"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Field = /** @class */ (function () {
    /* tslint:enable: typedef-whitespace */
    function Field(name, fieldDefinition) {
        /* tslint:disable: typedef-whitespace */
        this.attachCount = 1;
        this.errors = [];
        this.isFocused = false;
        this.isTouched = false;
        this.update(name, fieldDefinition);
    }
    Field.prototype.update = function (name, fieldDefinition) {
        this.name = name;
        this.initialValue = fieldDefinition[0];
        this.value = this.value || this.initialValue;
        this._rules = fieldDefinition[1];
    };
    Object.defineProperty(Field.prototype, "attached", {
        get: function () {
            return this.attachCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "isDirty", {
        get: function () {
            return this.value !== this.initialValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "isValid", {
        get: function () {
            return this.errors.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "rules", {
        get: function () {
            var _a;
            return this._rules ? (_a = {}, _a[this.name] = this._rules, _a) : {};
        },
        enumerable: true,
        configurable: true
    });
    Field.prototype.onFocus = function () {
        this.isFocused = true;
        if (!this.isTouched) {
            this.isTouched = true;
        }
    };
    Field.prototype.onBlur = function () {
        this.isFocused = false;
    };
    Field.prototype.onChange = function (value) {
        this.value = value;
    };
    Field.prototype.reset = function () {
        this.value = this.initialValue;
        this.isTouched = false;
    };
    Field.prototype.setTouched = function () {
        this.isTouched = true;
    };
    Field.prototype.detach = function () {
        if (this.attached) {
            this.attachCount = this.attachCount - 1;
        }
    };
    Field.prototype.subscribeToFormValidation = function (form) {
        var _this = this;
        return mobx_1.autorun(function () {
            var errors = form.errors.get(_this.name);
            if (_this.errors.join() !== errors.join()) {
                _this.errors = errors;
            }
        });
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], Field.prototype, "attachCount", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Field.prototype, "name", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Field.prototype, "value", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], Field.prototype, "errors", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Field.prototype, "isFocused", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Field.prototype, "isTouched", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Field.prototype, "_rules", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Field.prototype, "attached", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Field.prototype, "isDirty", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Field.prototype, "isValid", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Field.prototype, "rules", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Field.prototype, "onFocus", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Field.prototype, "onBlur", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Field.prototype, "onChange", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Field.prototype, "reset", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Field.prototype, "setTouched", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Field.prototype, "detach", null);
    return Field;
}());
exports.Field = Field;
//# sourceMappingURL=Field.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/Field.js
// module id = 125
// module chunks = 0